import "./App.css";
import { Route, Routes } from "react-router";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
// import ContactUs from "./pages/ContactUs";
import TermsAndConditions from "./pages/TermsAndConditions";
import Privacy from "./pages/Privacy";
import Services from "./pages/Services";
import Faq from "./components/Sections/Faq";
import IncidentReport from "./pages/IncidentReport";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import GoogleContact from "./pages/GoogleContact";
import Careers from "./pages/Careers";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        {/* <Route path="/contact-us" element={<ContactUs />} /> */}
        <Route path="/contact-us" element={<GoogleContact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/report" element={<IncidentReport />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/faq" element={<Faq />} />
      </Routes>
    </div>
  );
}

export default App;
